import React, { useEffect } from 'react';
import Categories from './Categories';
import Categories1 from './Categories1';
import Header from './Header';
import Products from './Products';
import SaleOffer from './SaleOffer';

const Home = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div>
			<Header />
			<Categories />
			<Categories1 />
			
			<Products />
			{/* <SaleOffer /> */}
		</div>
	);
};

export default Home;
